<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null,
      originalEntry: null
    };
  },
  props: {
    extras: null,
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(loadEntry) {
      this.originalEntry = loadEntry;
      this.editableEntry = _.cloneDeep(this.originalEntry);
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: AVAILABLE_ITENS_FOR_SALE_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: this.editableEntry.id,
          }
        })
        .then(response => {
          console.log("algo");
          // this.editableEntry.dummyExitMovementItemLotsAttributes = response.data.accountContext.dummySaleProduct.dummyExitMovementItemLotsAttributes;
          this.editableEntry.validations = response.data.accountContext.dummySaleProduct.validations;
          this.editableEntry.stockAdjustments = response.data.accountContext.dummySaleProduct.stockAdjustments;
          // console.log("stocka", this.editableEntry.stockAdjustments);
          // this.editableEntry.isPerformance = response.data.accountContext.dummySaleProduct.isPerformance;
          this.extraData = response.data;
          console.log("edit", this.extraData);
          this.extraData.customerId = this.extras.customerId;
          this.extraData.paymentConditionRuleId = this.extras.paymentConditionRuleId;
          this.extraData.accountContext.accountPermissions = this.extras.accountContext.accountPermissions;
        })
        .catch(response => console.log("erro aqui", response))
        .finally(() => (this.loading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.pageLoading = true;
        Object.assign(this.originalEntry, this.editableEntry);
        this.pageLoading = false;
        this.$refs.baseEdit.closeDialog();
        this.$emit("entry-updated", this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const AVAILABLE_ITENS_FOR_SALE_QUERY = gql `
  query($id: ID){
    accountContext {
      dummySaleProduct(id: $id) {
        isPerformance
        dummyExitMovementItemLotsAttributes{
          id
          manufacturingLotId
          quantity
          packagingQuantity
          isNewLot
          name
          lotNumber
          dueDate
          manufacturingDate
        }
        stockAdjustments{
          id
          code
          exitQuantity
          entryQuantity
          storageId
          storage{
            id
            name
          }
          isStockEntryType
          movementItemId
          adjustmentTypeText
          date
        }
        validations
      }

      availableItemsForSale {
        id
        name
        typeText
        unit {
          id
          name
        }
      }
    }
  }
`;
</script>

<style scoped></style>
